import GlobalChannelSettingsWindow from "./GlobalChannelSettingsWindow";
import SelectedImagesPreview from "./SelectedImagesPreview";
import GlobalChannelSettingsProvider from "./GlobalChannelSettingsProvider";
import GlobalChannelSettings from "./GlobalChannelSettings";
import DebuggerPanel from "./DebuggerPanel";
import SvgGrid from "./SvgGrid";
import G from './Getters';
import A from './ActionCreators';
import usePresentSelector from './usePresentSelector';
import Toolbar from './Toolbar';
import ValueDisplay from './ValueDisplay';
import ProteinQuantificationViewer from './ProteinQuantificationViewer';
import React, { useMemo, useState, useRef, useContext, useCallback } from 'react';
import { useStore, useDispatch, useSelector } from 'react-redux';

import ExportButton from './ExportButton';

import NewManualAnnotationGrid from './NewManualAnnotationGrid';

import FigureInfoSidebar from './FigureInfoSidebar';
import ColumnResizeProvider from './ColumnResizeProvider';

import FigureEditorModal from './FigureEditorModal';

import DragBoxLayer from './DragBoxLayer';

import FigureEditorContextMenuLayer from './FigureEditorContextMenuLayer';

import MicroscopyFilters from './MicroscopyFilters';

import ErrorBoundary from './ErrorBoundary';
import DragBoxHoverProvider from './DragBoxHoverProvider';
import MouseDragProvider from './MouseDragProvider';
import RowDragProvider from './RowDragProvider';
import CellDragEnteredProvider from './CellDragEnteredProvider'; 
import CropAdjustmentProvider from './CropAdjustmentProvider';
import MouseFocusProvider from './MouseFocusProvider';

import KeyDownListener from './KeyDownListener';

import FigureAsCanvas from './FigureAsCanvas';
import { debounce } from "./utils";

//import useKeyDownListener from './useKeyDownListener';

export default function FigureEditorContainer({
  figurePanelType,
  cropIdsBeingDragged,
  setSvg, 
  svg, 
  figurePanelId,
  cellValueInputRef,
}){

  const focusedOnValueDisplayRef = useRef(false);


  let [rows,cols] = usePresentSelector(state => G.getTableDimensions(state,figurePanelId));



  const [ popupMenuLocations, setPopupMenuLocations ] = useState({
    channelSettings:false,
    quantificationToolbar:false,
  });

  const [ quantificationToolbarVisible, setQuantificationToolbarVisible ] = useState(true);

  

  const [ selectionJustMade, setSelectionJustMade ] = useState(false);
  const [tableOutlineShowing,setTableOutlineShowing] = useState(true);
  const [retainInputFocus, setRetainInputFocus] = useState(false);

  /*let rowArrangedGridData = usePresentSelector(state => {
    return G.getCompleteGridLayoutData(state,{figurePanelId})
  });
  */



  //this is here to expose to the tuturial
  window.setSelectedCells = () => {
    throw Error("NEED TO ALIGN THIS FUNCTION FOR TESTING");
  };

  let valueDisplayProps = {
    selectionJustMade,
    setSelectionJustMade,
    tableOutlineShowing,setTableOutlineShowing, 
    cellValueInputRef,
    retainInputFocus,
  }



  let figureContent = (
    <NewManualAnnotationGrid 
        rows={rows} cols={cols}
        tableOutlineShowing={tableOutlineShowing}
        figurePanelId={figurePanelId}
      />
  )


  let beginnerInterface = (
    <div class="sg-col full-height flex-expand" style={{
      minHeight:0,
      position:'relative',
    }}>
      <div style={{justifyContent:'center',
        alignItems:'center',
      }}>
        Select crop regions to start your figure!
      </div>
    </div>
  )
  //return beginnerInterface;

  const keyDownListenerProps = {
    focusedOnValueDisplayRef,
    figurePanelId,
  } 

  const store = useStore();
  const state = store.getState();


  let template;
  let channels;
  if( figurePanelType !== "westernBlot" ){
    template= G.getFigurePanelTemplate(state,{
      figurePanelId,
      localTemplateId:"initTemplate"
    })
    channels = template?.channels;
  }else{
    channels = {"default":true}
  }
  

  const debounceAdjustmentChange = useCallback(debounce(adjustments => {
    store.dispatch(A.setChannelAdjustments({
      figurePanelId,
      adjustments,
    }));
  }, 300), [figurePanelId]);

  return (
    <>
      <MouseFocusProvider>
        <MouseDragProvider>
          <DragBoxHoverProvider>
            <ColumnResizeProvider figurePanelId={figurePanelId}>
              <CropAdjustmentProvider>
                <CellDragEnteredProvider>

                  <KeyDownListener {...keyDownListenerProps}>


                    <div style={{
                      minHeight:0,
                      minWidth:0,
                      position:'relative',
                    }} 

                      containerType={"sceneContainer"}
                      scene={"panelEditor"}
                      class="sg-col full-height flex-expand full-width">


                      


                      {true && <>
                      <div style={{
                        display:'flex',
                      }}>
                        <Toolbar {...{
                          figurePanelId,
                          setRetainInputFocus,
                          setPopupMenuLocations,
                          popupMenuLocations,
                        }}/>
                      </div>
                      <div style={{
                        position:'relative',
                        minHeight:0,
                        minWidth:0,
                        background:'none',
                      }} class="flex-expand sg-col full-width">

                        <ValueDisplay {...{...
                          valueDisplayProps, 
                          figurePanelId, 
                          focusedOnValueDisplayRef 
                        }}/>

                        <DragBoxLayer>
                          <RowDragProvider>

                            <GlobalChannelSettingsProvider 
                              defaultChannels={channels} 
                              onChange={debounceAdjustmentChange}>

                            <div style={{ 
                              minHeight:0,
                              minWidth:0,
                              justifyContent:'center',
                            }} class="sg-row">

                              <FigureEditorContextMenuLayer {...{
                                figurePanelId,
                              }}>

                                {figureContent}
                              </FigureEditorContextMenuLayer>



                              {true && <div style={{
                                position:'absolute',
                                bottom:5,
                                left:'50%'
                              }}>
                                  <ExportButton {...{setSvg,color:'green', key: figurePanelId, figurePanelId, button:"bottom-export-button"}}/>
                              </div>}


                              {popupMenuLocations.channelSettings && <GlobalChannelSettingsWindow initialPosition={popupMenuLocations.channelSettings} onClose={() => setPopupMenuLocations({...popupMenuLocations,channelSettings:false})} />}

                        {false && figurePanelType !== "microscopy" && <SelectedImagesPreview/>}

                              {false && quantificationToolbarVisible && <ProteinQuantificationViewer/>}


                            </div>

                            <div class="flex-expand"/>
                            </GlobalChannelSettingsProvider>
                          </RowDragProvider>

                        </DragBoxLayer>

                        <FigureInfoSidebar {...{ figurePanelId }}/>


                      </div>
                      </>}

                      {false && <MicroscopyFilters/>}

                    </div>

                    <FigureEditorModal/>

                    <DebuggerPanel/>

                  </KeyDownListener>
                </CellDragEnteredProvider>
              </CropAdjustmentProvider>
            </ColumnResizeProvider>
          </DragBoxHoverProvider>
        </MouseDragProvider>
      </MouseFocusProvider>

      {false && <FigureAsCanvas figurePanelId={figurePanelId}/>}

    </>
  )
}



